import { prognosticHtml } from '../prognostics/prognostic-markup'
import { instantSearchPostMarkUp } from './post-markup'
import { instantSearchBetHouseMarkUp } from './bet-house-markup'

(function($) {
  const searchForm = $('#searchform')
  const searchResultsWrp = $('#instant-search-results')
  const searchWrapper = $('#instant-search-results-wrapper')

  const instantSearchResultsWrapper = document.getElementById('instant-search-results');

  const handleResults = {
    'palpites': async function(value, append = false) {
      if (!!$('.instant-search-results__no-results').length && append)
        return

      const page = $(searchResultsWrp).attr('data-current-page')
      const response = await fetch(`${clubeCommon.restApiUrl}/palpites?search=${value}&per_page=6&page=${page}&_fields[]=id&_fields[]=link&_fields[]=tips_info&_fields[]=title`)
      const data = await response.json()

      if (!!!data.length) {
        const msg = '<span class="instant-search-results__no-results">Sem resultados disponíveis que satisfaçam sua pesquisa!</span>'
        !append ? $(searchResultsWrp).html(msg) : $(searchResultsWrp).append(msg)
        return
      }

      $(searchForm).removeClass(['has-result-palpites', 'has-result-post', 'has-result-casa-de-apostas'])
      $(searchForm).addClass(`has-result-palpites`)
      append ? $(searchResultsWrp).append(prognosticHtml.render({data})) : $(searchResultsWrp).html(prognosticHtml.render({data}))
    },
    'post': async function(value, append = false) {
      if (!!$('.instant-search-results__no-results').length && append)
        return

      const page = $(searchResultsWrp).attr('data-current-page')
      const response = await fetch(`${clubeCommon.restApiUrl}/search?search=${value}&per_page=6&page=${page}&subtype[]=post&subtype[]=casa-de-apostas&_fields[]=author_name&_fields[]=excerpt_post&_fields[]=featured_media_post&_fields[]=id&_fields[]=link&_fields[]=title&_fields[]=url`)
      const data = await response.json()

      if (!!!data.length) {
        const msg = '<span class="instant-search-results__no-results">Sem resultados disponíveis que satisfaçam sua pesquisa!</span>'
        !append ? $(searchResultsWrp).html(msg) : $(searchResultsWrp).append(msg)
        return
      }

      const content = window.innerWidth <= 992 ? instantSearchPostMarkUp.renderMobile(data) : instantSearchPostMarkUp.render(data)

      $(searchForm).removeClass(['has-result-palpites', 'has-result-post', 'has-result-casa-de-apostas'])
      $(searchForm).addClass(`has-result-post`)

      append ? $(searchResultsWrp).append(content) : $(searchResultsWrp).html(content)
    },
    'casa-de-apostas': async function(value, append = false) {
      if (!!$('.instant-search-results__no-results').length && append)
        return

      const page = $(searchResultsWrp).attr('data-current-page')
      const response = await fetch(`${clubeCommon.restApiUrl}/casa-de-apostas?search=${value}&per_page=6&page=${page}&_fields[]=id&_fields[]=link&_fields[]=title&_fields[]=logo_image&_fields[]=bar_color&_fields[]=card_subtitle&_fields[]=link_button_bet`)
      const data = await response.json()

      if (!!!data.length) {
        const msg = '<span class="instant-search-results__no-results">Sem resultados disponíveis que satisfaçam sua pesquisa!</span>'
        !append ? $(searchResultsWrp).html(msg) : $(searchResultsWrp).append(msg)
        return
      }

      const content = window.innerWidth <= 992 ? instantSearchBetHouseMarkUp.renderMobile(data) : instantSearchBetHouseMarkUp.render(data)

      $(searchForm).removeClass(['has-result-palpites', 'has-result-post', 'has-result-casa-de-apostas'])
      $(searchForm).addClass(`has-result-casa-de-apostas`)
      append ? $(searchResultsWrp).append(content) : $(searchResultsWrp).html(content)
    }
  }

  $(document).ready(async function() {
    async function getInstantSearch(value, append = false) {
      const searchType = document.querySelector('#searchform [name="HeaderClub-search-form-type"]:checked')

      if (value.trim() === '') {
        $(searchResultsWrp).html('')
        $(searchResultsWrp).attr('data-current-page', 1)
        $(searchForm).removeClass(['has-result-palpites', 'has-result-post', 'has-result-casa-de-apostas'])
        return
      }

      $(searchResultsWrp).attr('data-current-page', !append ? 1 : parseInt($(searchResultsWrp).attr('data-current-page')) + 1)
      $(searchWrapper).addClass('is-loading')

      if (!append)
        $(searchResultsWrp).html('')

      await handleResults[searchType.dataset.cpt](value, append)

      $(searchWrapper).removeClass('is-loading')
    }

    $('#iconSearch').on('click', function toggleSearch(event) {
      if(!content.classList.contains('show')) {
        content.classList.add('show');
        content.classList.remove('hide');
        document.body.classList.add('searching');
        outsideContent.style.cssText = "display: flex";
        document.querySelector('#s-wrapper .HeaderClub-search-form-field-input').focus()

        event.preventDefault();
      }
      else {
        content.classList.remove('show');
        content.classList.add('hide');
        document.body.classList.remove('searching');
        outsideContent.style.cssText = "display: none";
        cleanStatusOnClose()

        event.preventDefault();
      }
    })

    $('#outsideContent').on('click', function closeSearchContainer(event){
      content.classList.remove('show');
      content.classList.add('hide');
      outsideContent.style.cssText = "display: none";
      cleanStatusOnClose()

      event.preventDefault();
    })

    if (typeof $.debounce === 'function') {
      $('#main-site-search').keyup($.debounce(500, (e) => getInstantSearch(e.target.value)))
    }

    $('[type="radio"][name="HeaderClub-search-form-type"]').on('change', function({ target }) {
      const searchValue = $('#main-site-search').first().val()
      if (!searchValue)
        return

      getInstantSearch(searchValue)
    })

    function cleanStatusOnClose() {
      $(searchResultsWrp).html('')
      $(searchForm).removeClass(['has-result-palpites', 'has-result-post', 'has-result-casa-de-apostas'])
      $('#main-site-search').val('')
      $('[type="radio"][name="HeaderClub-search-form-type"][value="palpites"').prop('checked', true)
    }

    if (instantSearchResultsWrapper) {
      instantSearchResultsWrapper.addEventListener(
        'scroll',
        function()
        {
          if ($(searchWrapper).hasClass('is-loading')) {
            return
          }

          const scrollTop = instantSearchResultsWrapper.scrollTop;
          const scrollHeight = instantSearchResultsWrapper.scrollHeight; // added
          const offsetHeight = instantSearchResultsWrapper.offsetHeight;
          // const clientHeight = instantSearchResultsWrapper.clientHeight;
          const contentHeight = scrollHeight - offsetHeight; // added

          if (contentHeight <= Math.ceil(scrollTop)) {
            // console.log('opa')
            const searchValue = $('#main-site-search').first().val()
            if (!searchValue)
              return

            getInstantSearch(searchValue, true)
          }
        },
        false
      )
    }
  })
})(jQuery)
